const moduleName = 'osm';

import { components } from 'linksoft';

import osm from './osm';

components.add('osm', osm);

export default {
    name: moduleName,
    containers: [osm],
};


// WEBPACK FOOTER //
// ./App/components/modules/osm/index.js